<template>
  <div
      v-if="hasInit"
  >
    <router-view/>

    <notifications position="bottom center"/>
  </div>
</template>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700;800&display=swap");

html, body {
  background-color: #E9F6F6;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: rgb(215 227 227);
  border-radius: 1rem;
}

@media screen and (min-width: 280px) {
  .slide-fade-back-enter-active,
  .slide-fade-back-leave-active {
    transition: all 0.4s ease-out;
  }

  .slide-fade-back-enter {
    opacity: 0;
    transform: translateX(150%);
  }

  .slide-fade-back-leave-to {
    transform: translateX(-150%);
    opacity: 0;
  }

  .slide-fade-forward-enter-active,
  .slide-fade-forward-leave-active {
    transition: all 0.4s ease-out;
  }

  .slide-fade-forward-enter {
    opacity: 0;
    transform: translateX(-150%);
  }

  .slide-fade-forward-leave-to {
    transform: translateX(150%);
    opacity: 0;
  }
}

</style>

<script>
import {gsap} from "gsap";
import {ScrollToPlugin} from "gsap/ScrollToPlugin";
import CommonMixin from '@/mixins/common.mixin'
import SessionMixin from "@/mixins/session.mixin";
import {mapGetters} from "vuex";

gsap.registerPlugin(ScrollToPlugin);

export default {
  name: 'POBR',
  mixins: [
    CommonMixin,
    SessionMixin
  ],

  data: () => {
    return {
      hasInit: false
    }
  },

  computed: {
    ...mapGetters(['queryObject'])
  },

  async created() {
    this.buildQueryObject();
    await this.getSessionToken();
    await this.fetchHeaderLabel(this.queryObject);

    this.hasInit = true;
  }
}
</script>
